import { QueryState } from '../../../common/enums';
import { Nullable } from '../../../common/utils';

export interface ITokenAttributeValue {
  [key: string]: string | { [key: string]: string }[];
}

export interface ITokenAttributeEntry {
  [key: string]: ITokenAttributeValue[];
}

export interface ITokenVerificationPayload {
  id?: string;
  pvActiveGroupID?: number;
  attributes?: ITokenAttributeEntry[];
  accessToken?: string;
  email?: string;
  status?: string;
  pvPersonGivenName?: string;
  pvPersonSurName?: string;
  pvOfficePhone?: string;
  pvMobilePhone?: string;
  accessType?: string;
}

export interface ITokenState {
  state: QueryState;
  tokenVerification: Nullable<ITokenVerificationPayload>;
  error: Nullable<string>;
}

export const TokenEmptyState: ITokenState = {
  state: QueryState.UNDEFINED,
  tokenVerification: null,
  error: null
};
